module.exports = __webpack_public_path__ + "img/Heard Island and McDonald Islands.c6552000.svg";